import { themeColors } from "../../config.js";

export const loginStyles = {
  container: {
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: themeColors.transparentBlack,
  },
  modal: {
    padding: 20,
    borderRadius: 20,
    fontSize: 12,
    width: 300,
    fontFamily: "roboto",
    backgroundColor: themeColors.transparentBlack,
    color: themeColors.transparentWhite,
    display: "flex",
    flexDirection: "column",
  },
  label: {
    display: "flex",
    marginTop: 10,
    marginBottom: 5,
    justifyContent: "center",
    alignItems: "center",
    alignSelf: "stretch",
    flexDirection: "column",
  },
  button: {
    fontSize: 12,
    fontFamily: "roboto",
    margin: 10,
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    borderRadius: 10,
    backgroundColor: themeColors.transparentBlack,
  },
  input: {
    fontSize: 15,
    borderRadius: 5,
    marginBottom: 10,
    width: "100%",
    fontFamily: "roboto",
    textShadow: "0 0 5px white",
    padding: 2,
    outline: "none",
    border: "none",
    backgroundColor: themeColors.optionColor,
    color: themeColors.transparentWhite,
  },
};
